import Footer from "../../components/Footer/Footer"
import Sponsors from "../../components/Sponsors"
import MainSection from "./MainSection"
import MainSectionMobile from "./MainSectionMobile"
import TopBanner from "./TopBanner"

const HomePage = () => {
  return (
    <div className="w-screen flex flex-col justify-center items-center bg-[#171715] overflow-y-scroll">
        <TopBanner />
        <div className="h-[50px]"/>
        <div className="hidden md:block">
            <MainSection />
        </div>
        <div className="block md:hidden">
            <MainSectionMobile />
        </div>
        <Sponsors />
        <Footer />
        <div className='h-[50px]'/>
    </div>
  )
}

export default HomePage
